import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const SejaFranqueado = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Defina a largura que considera como mobile
    };

    handleResize(); // Chama na inicialização
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleClick = () => {
    // Rastreando o evento no Google Analytics
    if (window.gtag) {
      window.gtag('event', 'banner_franqueado', {
        event_category: 'Banner',
        event_label: 'Seja Franqueado Banner',
        value: 1,
      });
    }
  };

  const imageUrl = isMobile 
    ? "img/banner/seja_franqueado_mobile.webp" // URL da imagem mobile
    : "img/banner/seja_franqueado_desktop.webp"; // URL da imagem desktop

  return (
    <Link to='https://sejaumfranqueado.pizzaprime.com.br/?utm_source=GoogleBL&utm_medium=SearchFranquiaRamo&utm_campaign=Search&utm_content=AD01&gad_source=1&gclid=Cj0KCQiAhvK8BhDfARIsABsPy4gLE_CqU_Ms3IF40692OoCeXFAWB0n7zNS3Hrz78pNJqFaaB8KIaFMaAt9oEALw_wcB' target='_blank' onClick={handleClick}>
      <img src={imageUrl} alt="Pizza Prime" style={{ width: '100%', height: 'auto' }} />
    </Link>
  );
};

export default SejaFranqueado;
